export default {"src":"/_next/static/media/hotel-icon-selected.843f9703.svg","height":94,"width":143,"blurWidth":0,"blurHeight":0};